import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience, createMarkedJpdExperience } from '../../utils/experience/main.tsx';
import type { JPDExperience } from '../../utils/experience/types.tsx';

export const applyTemplateMarks = {
	APPLY_TEMPLATE_POLLING_START_MARK: 'apply_template_polling_start',
	APPLY_TEMPLATE_POLLING_STOP_MARK: 'apply_template_polling_stop',
} as const;

export const pageLoad: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.project', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageLoad,
	}),
);

// Separate experience for rate limit errors
export const pageLoadWithRateLimit: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.project.rate-limit', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageLoad,
	}),
);

export const applyTemplate = createMarkedJpdExperience(
	new UFOExperience('jpd.project.apply-template', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.Custom,
		timings: [
			{
				key: 'apply_template_polling',
				startMark: applyTemplateMarks.APPLY_TEMPLATE_POLLING_START_MARK,
				endMark: applyTemplateMarks.APPLY_TEMPLATE_POLLING_STOP_MARK,
			},
		],
	}),
	applyTemplateMarks,
);

export const create: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.project.create', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const createAsyncOnboarding: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.project.create-async-onboarding', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);
